import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M10 16.6667c-3.675 0-6.6667-2.9917-6.6667-6.6667S6.325 3.3333 10 3.3333 16.6666 6.325 16.6666 10 13.675 16.6667 10 16.6667m0 1.6666c4.6 0 8.3333-3.7333 8.3333-8.3333S14.6 1.6667 10 1.6667 1.6666 5.4 1.6666 10 5.4 18.3333 10 18.3333M9.1666 10v3.3333h1.6667V10h2.5L10 6.6667 6.6666 10z" /></g>,<defs key="1"></defs>,]
, 'DisplayArrowCircleUpx');
